document.addEventListener("DOMContentLoaded", function () {
    const today = new Date();
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    // Current Date
    const yearElement = document.getElementById("currentsYrs");
    const dateElement = document.getElementById("currentsDts");

    if (yearElement) yearElement.innerHTML = today.getFullYear();
    if (dateElement) dateElement.innerHTML = months[today.getMonth()] + " " + today.getDate() + ", " + today.getFullYear();

    // Generate future dates dynamically
    for (let i = 7; i <= 161; i += 7) {
        let futureDate = new Date(today.getTime() + i * 24 * 60 * 60 * 1000);
        let elementId = `nextDate${i}`;
        let futureDateElement = document.getElementById(elementId);

        if (futureDateElement) {
            futureDateElement.innerHTML = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${futureDate.getFullYear()}`;
        }
    }
});
